import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { DisciplineService } from '../../../services/DisciplineService';
import { NiveauService } from '../../../services/NiveauService';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { AdresseService } from '../../../services/AdresseService';
import { CoursService } from '../../../services/CoursService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * disabled: boolean qui permet de desactiver le formulaire
     */
    disabled: boolean;
    /**
     * Course: le cours indexé
     */
    course: ReqType.Course;
    /**
     * changer l'état externe du cours indexé
     * @param {Course} course
     */
    setCourse: (course: ReqType.Course) => void;
}

/**
 * interface State (l'état interne de la classe CourseForm)
 */
interface State {
    /**
     * disciplines: l'ensemble des disciplines pour un cours donné
     */
    disciplines: ReqType.Discipline[];
    /**
     * levels: l'ensemble des niveaux pour un cours donné
     */
    levels: ReqType.Niveau[];
    /**
     * date: la date du cours en question
     */
    date: Date;
}

/**
 * Ce composant permet d'ajouter un cours (formulaire). Il prend un tableau de discipline,
 * un tableau de niveau et une date. Les services appellé pour récupérer l'ensemble des niveaux et
 * des disciplines sont disciplineservice et niveauServices.
 */
export class CourseForm extends React.Component {
    /** le props: l'etat externe */
    props: Props;
    /** le state: l'etat interne */
    state: State;

    /**
     * construit le formulaire pour un cours
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            disciplines: [],
            levels: [],
            date: new Date(),
        };
        this.getDisciplines();
        this.getLevels();
    }

    /**
     * le rendu de la classe course forme
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div className="col-12" style={{paddingTop: '20px'}}>
                {this.disciplineInput()}
                {this.niveauInput()}
                {this.jourInput()}
                {this.horaireInput()}
                {this.tagInput()}
                {this.detailsInput()}
                {this.adresseInput()}
            </div>
        );
    }

    /**
     * Fait un get du tableau de discipline disponible depuis le backend
     * Initialise le state (disciplines) avec ces valeurs.
     */
    private getDisciplines() {
        DisciplineService.getInstance().getDisciplineList(
        ).then(
            (r: ReqType.Discipline[]) => {
                var arr: ReqType.Discipline[] = [];
                r.map(
                    (e: ReqType.Discipline) => {
                        arr[e.id] = e;
                    }
                );
                this.setState({ disciplines: arr });
            }
        );
    }
    /**
     * Fait un get du tableau de discipline Niveau depuis le backend
     * Initialise le state (levels) avec ces valeurs.
     */
    private getLevels() {
        NiveauService.getInstance().getNiveauList(
        ).then(
            (r: ReqType.Niveau[]) => {
                var arr: ReqType.Niveau[] = [];
                r.map(
                    (e: ReqType.Niveau) => {
                        arr[e.id] = e;
                    }
                );
                this.setState({ levels: arr });
            }
        );
    }

    /**
     * Permet l'affichage des disciplines
     * @returns {JSX.Element}
     */
    private disciplineInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="discipline"
                        className="col-form-label-lg"
                    >
                        Discipline:
                    </label>
                </div>

                <div className="col-10">
                    <select
                        className="form-control-lg"
                        name="discipline"
                        value={this.props.course.discipline.id}
                        onChange={
                            (e: React.ChangeEvent<HTMLSelectElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.discipline = this.state.disciplines[Number.parseInt(e.target.value)];
                                this.props.setCourse(newCourse);
                            }
                        }
                        disabled={this.props.disabled}
                    >
                        <option value="-1" disabled={true} selected={true}>
                            Selectionnez une discipline
                        </option>
                        {this.state.disciplines.map(
                            (e: ReqType.Discipline, i: number) => {
                                return (<option key={i} value={i}>
                                    {e.intitule}
                                </option>
                                );
                            }
                        )}
                    </select>
                </div>
            </div>
        );
    }

    /**
     * Permet l'affichage des Niveaux
     * @returns {JSX.Element}
     */
    private niveauInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="niveau"
                        className="col-form-label-lg"
                    >
                        Niveau:
                    </label>
                </div>

                <div className="col-10">
                    <select
                        className="form-control-lg"
                        name="niveau"
                        value={this.props.course.niveau.id}
                        onChange={
                            (e: React.ChangeEvent<HTMLSelectElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.niveau = this.state.levels[e.target.value];
                                this.props.setCourse(newCourse);
                            }
                        }
                        disabled={this.props.disabled}
                    >
                        <option value="-1" disabled={true} selected={true}>
                            Selectionnez un niveau
                    </option>
                        {this.state.levels.map(
                            (e: ReqType.Niveau, i: number) => {
                                return (<option key={i} value={i}>
                                    {e.intitule}
                                </option>
                                );
                            }
                        )}
                    </select>
                </div>
            </div>
        );
    }

    private tagInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="niveau"
                        className="col-form-label-lg"
                    >
                        Nom du Tag:
                    </label>
                </div>

                <div className="col-10">
                    <input
                        className="form-control-lg"
                        placeholder="Nom du tag"
                        type="text"
                        value={this.props.course.tag.nom}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.tag.nom = e.target.value;
                                this.props.setCourse(newCourse);
                            }
                        }
                    />
                </div>
            </div>
        );
    }

    private horaireInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="niveau"
                        className="col-form-label-lg"
                    >
                        Horaire:
                    </label>
                </div>

                <div className="col-10">
                    <input
                        className="form-control-lg"
                        placeholder="Horaire"
                        type="text"
                        value={this.props.course.horaire}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.horaire = e.target.value;
                                this.props.setCourse(newCourse);
                            }
                        }
                    />
                </div>
            </div>
        );
    }

    /**
     * Permet l'affichage des details d'un cours
     * @returns {JSX.Element}
     */
    private detailsInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="Detail"
                        className="col-form-label-lg"
                    >
                        Detail:
                    </label>
                </div>
                <div className="col-10">
                    <input
                        className="form-control-lg"
                        placeholder="Detail"
                        type="text"
                        value={this.props.course.details}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.details = e.target.value;
                                this.props.setCourse(newCourse);
                            }
                        }
                    />
                </div>
            </div>
        );
    }

    /**
     * Permet l'affichage le jour que à lieux cours
     * @returns {JSX.Element}
     */
    private jourInput() {
        return (
            <div className="form-group row">
                <div className="text-right col-2">
                    <label
                        htmlFor="Jour"
                        className="col-form-label-lg"
                    >
                        Jour:
                    </label>
                </div>
                <div className="col-10">
                    <select
                        className="form-control-lg"
                        value={this.props.course.jour}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLSelectElement>) => {
                                var newCourse: ReqType.Course =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.jour = e.target.value;
                                this.props.setCourse(newCourse);
                            }
                        }
                    >
                        <option value="" disabled={true}>Veuillez choisir un jour</option>
                        <option value="lundi">Lundi</option>
                        <option value="mardi">Mardi</option>
                        <option value="mercredi">Mercredi</option>
                        <option value="jeudi">Jeudi</option>
                        <option value="vendredi">Vendredi</option>
                        <option value="samedi">Samedi</option>
                        <option value="dimanche">Dimanche</option>
                    </select>
                </div>
            </div>
        );
    }

    /**
     * Permet l'affichage de l'adresse ou a lieux cours
     * @returns {JSX.Element}
     */
    private adresseInput() {
        return (
            <div className="form-group row">
                <label htmlFor="Adresse" className="col-2 text-right col-form-label-lg">
                    Adresse:
                </label>

                <div className="col-10">
                    <AdresseForm
                        adresse={AdresseService.getInstance().duplicateAdresse(this.props.course.adresse)}
                        disabled={this.props.disabled}
                        setAdresse={
                            (adresse: ReqType.Adresse) => {
                                const newCourse =
                                    CoursService.getInstance().duplicateCourse(this.props.course);
                                newCourse.adresse = adresse;
                                this.props.setCourse(newCourse);
                            }
                        }
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/internalComponents/CourseForm.tsx